import { isValidPhone } from './mask'
import type { FieldDefinition, ValidationMessages } from './types'

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/
const LETTERS_PATTERN = /^[\p{L}\s'.-]+$/u
const NUMBER_PATTERN = /^-?\d+([.,]\d+)?$/
const INTEGER_PATTERN = /^-?\d+$/

function format(template: string, params: Record<string, number | null | undefined>): string {
  return template.replace(/\{(\w+)\}/g, (match, key: string) => {
    const value = params[key]
    return value === null || value === undefined ? match : String(value)
  })
}

export function validateField(field: FieldDefinition, raw: string, messages: ValidationMessages): string | null {
  const value = raw.trim()
  if (value === '') {
    if (!field.required) return null
    const isSelect = field.kind === 'selectbox' || field.kind === 'state' || field.kind === 'city'
    return isSelect ? messages.requiredSelect : messages.required
  }

  if (field.kind === 'phone' && !isValidPhone(value)) return messages.phone

  const numeric = field.kind === 'number' || field.inputType === 'number'
  if (field.inputType === 'email' && !EMAIL_PATTERN.test(value)) return messages.email
  if (field.inputType === 'integer' && !INTEGER_PATTERN.test(value)) return messages.integer
  if (numeric && field.inputType !== 'integer' && !NUMBER_PATTERN.test(value)) return messages.number
  if (field.inputType === 'letters' && !LETTERS_PATTERN.test(value)) return messages.letters

  const params = { min: field.minLength, max: field.maxLength }
  if (field.kind !== 'phone' && typeof field.minLength === 'number' && value.length < field.minLength) {
    return format(messages.minLength, params)
  }
  if (field.kind !== 'phone' && typeof field.maxLength === 'number' && value.length > field.maxLength) {
    return format(messages.maxLength, params)
  }
  return null
}

export function stripAccents(value: string): string {
  return value.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
}

export function containsBlockedWord(value: string, blockedWords: string[]): boolean {
  const haystack = stripAccents(value)
  return blockedWords.some((word) => {
    const needle = stripAccents(word.trim())
    return needle !== '' && haystack.includes(needle)
  })
}
